import { render, staticRenderFns } from "./CasLoyout.vue?vue&type=template&id=6d385c0f&scoped=true"
import script from "./CasLoyout.vue?vue&type=script&lang=js"
export * from "./CasLoyout.vue?vue&type=script&lang=js"
import style0 from "./CasLoyout.vue?vue&type=style&index=0&id=6d385c0f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d385c0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d385c0f')) {
      api.createRecord('6d385c0f', component.options)
    } else {
      api.reload('6d385c0f', component.options)
    }
    module.hot.accept("./CasLoyout.vue?vue&type=template&id=6d385c0f&scoped=true", function () {
      api.rerender('6d385c0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/loyout/CasLoyout.vue"
export default component.exports